/** Mention entity type from the API (e.g. skill, prompt, integration, workflow). */
export type MentionSearchType = string;

/** Query param value for GET /mentions/search → `types=skill` (was `skill,prompt`) */
export const MENTION_SEARCH_TYPES_PARAM = [
  'skill',
  // Prompts are hidden from the composer `/` menu for now. Restore with the Prompts
  // category: uncomment 'prompt' here and drop it from HIDDEN_MENTION_SEARCH_TYPES below.
  // 'prompt',
] as const;

/**
 * Types the `/` picker never shows, even if a mentions response still returns them
 * (items and categories). Restore with the Prompts category by removing 'prompt' here.
 */
export const HIDDEN_MENTION_SEARCH_TYPES: readonly MentionSearchType[] = ['prompt'];

export interface IMentionsSearchParams {
  q?: string;
  types?: MentionSearchType[];
  surface?: string;
  limit?: number;
}

/** Raw mention row from GET /mentions/search */
export type MentionSearchApiItem = {
  type: string;
  id: string;
  name: string;
  description?: string | null;
  iconUrl?: string | null;
};

export type MentionsSearchApiResponse =
  | MentionSearchApiItem[]
  | {
      success?: boolean;
      message?: string;
      data?: unknown;
      items?: unknown[];
      results?: unknown[];
    };
